export default __webpack_public_path__ + "static/media/QRupload_duotone.d2c99e42.svg";